import { Card, CardContent } from '@/components/ui/card';
import QRCode from 'qrcode';
import { useState, useEffect } from 'react';

export default function TicketPreview({ 
  ticketType, 
  customImage, 
  imagePosition = 'top-right', 
  imageOpacity = 100,
  tenant 
}) {
  const [qrDataUrl, setQrDataUrl] = useState('');

  useEffect(() => {
    generateQR();
  }, [ticketType]);

  const generateQR = async () => {
    try {
      const qrData = await QRCode.toDataURL('SAMPLE-TICKET-123', {
        width: 200,
        color: {
          dark: ticketType?.qr_color || '#000000',
          light: ticketType?.qr_bg_color || '#FFFFFF'
        }
      });
      setQrDataUrl(qrData);
    } catch (error) {
      console.error('Error generating QR:', error);
    }
  };

  const getImageStyle = () => {
    const baseStyle = {
      opacity: imageOpacity / 100,
      maxWidth: '150px',
      maxHeight: '100px',
      objectFit: 'contain'
    };

    switch (imagePosition) {
      case 'top-left':
        return {
          ...baseStyle,
          position: 'absolute',
          top: '20px',
          left: '20px'
        };
      case 'top-right':
        return {
          ...baseStyle,
          position: 'absolute',
          top: '20px',
          right: '20px'
        };
      case 'watermark':
        return {
          ...baseStyle,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: '300px',
          maxHeight: '200px',
          opacity: (imageOpacity / 100) * 0.3 // Extra transparency for watermark
        };
      default:
        return baseStyle;
    }
  };

  return (
    <Card className="w-full max-w-2xl">
      <CardContent className="p-0">
        <div className="relative bg-gradient-to-br from-purple-50 to-blue-50 p-8" style={{ minHeight: '400px' }}>
          {/* Custom Image */}
          {customImage && (
            <img 
              src={customImage} 
              alt="Custom ticket image" 
              style={getImageStyle()}
            />
          )}

          {/* Header */}
          <div className={`mb-6 ${customImage && imagePosition === 'top-left' ? 'ml-40' : ''}`}>
            {tenant?.logo && (
              <img src={tenant.logo} alt="Logo" className="h-12 mb-2" />
            )}
            <h2 className="text-2xl font-bold text-gray-900">
              {ticketType?.name || 'Nome Biglietto'}
            </h2>
            <p className="text-gray-600 text-sm">
              {ticketType?.description || 'Descrizione biglietto'}
            </p>
          </div>

          {/* Content */}
          <div className="grid grid-cols-2 gap-6 mb-6">
            <div>
              <p className="text-xs text-gray-500 uppercase mb-1">Prezzo</p>
              <p className="text-2xl font-bold text-purple-600">
                €{ticketType?.price?.toFixed(2) || '0.00'}
              </p>
            </div>
            <div>
              <p className="text-xs text-gray-500 uppercase mb-1">Tipo</p>
              <p className="text-lg font-semibold text-gray-900">
                {ticketType?.name || '-'}
              </p>
            </div>
          </div>

          {/* QR Code */}
          <div className="flex justify-center">
            {qrDataUrl && (
              <div className="bg-white p-4 rounded-lg shadow-lg">
                <img src={qrDataUrl} alt="QR Code" className="w-48 h-48" />
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="mt-6 pt-4 border-t border-gray-300 text-center">
            <p className="text-xs text-gray-500">
              Powered by ZonePass - Sistema Gestione Eventi
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
